<div class="information" [class.mini]="size === 'mini'">
  <div class="semaphore" [ngClass]="size">
    <svg
      attr.width="{{ sizeSvg }}"
      attr.height="{{ sizeSvg }}"
      viewBox="0 0 30 30"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink">
      <g id="Web" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g transform="translate(-194.000000, -474.000000)" [attr.fill]="color">
          <g id="Group-5" transform="translate(194.000000, 474.000000)">
            <g
              id="Group"
              transform="translate(15.000000, 15.000000) rotate(-270.000000) translate(-15.000000, -15.000000) ">
              <path
                d="M29.69445,14.9557836 L29.69445,29.7103445 L15.1383471,29.7103445 C7.09927461,29.7103445 0.582244118,23.1044608 0.582244118,14.9557836 C0.582244118,6.80730007 7.09927461,0.201416351 15.1383471,0.201416351 C23.1774195,0.201416351 29.69445,6.80730007 29.69445,14.9557836"
                id="Fill-1"
                transform="translate(15.138347, 14.955880) rotate(-90.000000) translate(-15.138347, -14.955880) ">
              </path>
            </g>
          </g>
        </g>
      </g>
    </svg>
    <p class="petal-text" [innerHTML]="text"></p>
  </div>
</div>
